/** Reason string from `VisitorScreening::IdScanVeriffService::MSG_VERIFICATION_TIMEOUT`. */
const REASON_VERIFICATION_TIMEOUT = 'ID Verification Timed Out';

const NO_ID_PROVIDED_TILE = 'No ID was provided at sign-in.';
const NO_ID_PROVIDED_FEED = 'Visitor’s ID was not provided. Please review for entry.';
const TIMED_OUT_FEED = 'Visitor’s ID check could not be completed. Please review for entry.';
// Straight apostrophe is load-bearing — acceptance tests assert this string byte-for-byte.
const REJECTED_FEED = "Visitor's ID was rejected.";

interface IdScanningHoldReport {
  reason?: string | null;
  veriffSessionId?: string | null;
}

// A session is only minted by a kiosk scan or the bypass flow, so its absence means no
// ID was ever presented — dashboard sign-ins have no scan step at all.
function noIdProvided(report: IdScanningHoldReport): boolean {
  return !report.veriffSessionId;
}

/** Entry-detail card line, falling back to the reason this card has always shown verbatim. */
export function idScanningHoldTileMessage(report: IdScanningHoldReport): string {
  if (noIdProvided(report)) return NO_ID_PROVIDED_TILE;
  return report.reason ?? '';
}

/** Visitor-log and approvals feed sentence, in the register that ends with a call to review. */
export function idScanningHoldFeedMessage(report: IdScanningHoldReport | undefined): string {
  if (!report) return REJECTED_FEED;
  if (noIdProvided(report)) return NO_ID_PROVIDED_FEED;
  if (report.reason === REASON_VERIFICATION_TIMEOUT) return TIMED_OUT_FEED;
  return REJECTED_FEED;
}
